<template>
    <el-dialog class="preview-dialog" title="职位预览" :visible.sync="dialogVisible">
        <el-form class="preview-inlineForm" :inline="true" v-if="baseData">
            <el-form-item label="职位名称" :label-width="formLabelWidth">
                {{baseData.name}}【{{baseData.code}}】
            </el-form-item>
            <el-form-item label="职位状态" :label-width="formLabelWidth">
                <span style="font-weight: bold">{{getSelectMapText('WB_POSITION_STATE', baseData.state)}}</span>
            </el-form-item>
            <el-form-item label="办公地点" :label-width="formLabelWidth">
                {{ baseData.workPlace }}
            </el-form-item>
            <el-form-item label="岗位序列" :label-width="formLabelWidth">
                {{ getSelectMapText('WB_POSITION_SEQUENCE_ALL', baseData.sequenceMain) }}
            </el-form-item>
            <el-form-item label="岗位子序列" :label-width="formLabelWidth">
                {{ getSelectMapText('WB_POSITION_SEQUENCE_ALL', baseData.sequenceSub) }}
            </el-form-item>
            <el-form-item label="发布暂停时间" :label-width="formLabelWidth">
                {{baseData.onlineDate ? baseData.onlineDate.slice(0, 10) : '无'}}
                至
                {{baseData.offlineDate ? baseData.offlineDate.slice(0, 10) : '无'}}
            </el-form-item>
            <el-form-item label="工作地点" :label-width="formLabelWidth">
                {{baseData.cityNames}}
            </el-form-item>
            <el-form-item label="招聘人数" :label-width="formLabelWidth">
                {{baseData.recruitCount || '不限'}}
            </el-form-item>
            <el-form-item label="是否门户展示" :label-width="formLabelWidth">
                {{ baseData.showInDesk == 1 ? '是' : '否'}}
            </el-form-item>
            <el-form-item label="招聘范围" :label-width="formLabelWidth">
                {{ getSelectMapText('WB_PROPERTY_TYPE', baseData.property) }}
            </el-form-item>
            <el-form-item label="工作性质" :label-width="formLabelWidth">
                {{baseData.workType}}
            </el-form-item>
            <el-form-item label="定薪规则" :label-width="formLabelWidth" v-if="baseData.paymentId && baseData.paymentState">
                {{baseData.paymentName}}
            </el-form-item>
        </el-form>
        <el-form  v-if="baseData">
            <el-form-item label="内推职位" :label-width="formLabelWidth">
                {{ getSelectMapText('WB_YES_OR_NO', baseData.recommendable) || '-' }}
            </el-form-item>
            <el-form-item label="供应商" :label-width="formLabelWidth" v-if="baseData.toSupplier">
                <span
                    v-for="item in baseData.linkmanIdList"
                    :key="item.id"
                    class="mr-15"
                >{{ getSupplierStr(item) }}</span>
            </el-form-item>
            <el-form-item label="应聘部门" :label-width="formLabelWidth">
                {{baseData.deptNames}}
            </el-form-item>
            <el-form-item label="岗位建议方向" :label-width="formLabelWidth">
                {{baseData.advise}}
            </el-form-item>
            <el-form-item label="职位职责" :label-width="formLabelWidth">
                <pre>{{baseData.description}}</pre>
            </el-form-item>
            <el-form-item label="要求" :label-width="formLabelWidth">
                <pre>{{baseData.requirement}}</pre>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<style lang="scss">
    .preview-inlineForm{
        .el-form-item__label{
            color: #9e9e9e;
        }
        .el-form-item{
            width: 300px;
            margin: 4px 0;
        }
        .el-form-item__content{
            width: 180px !important;
        }
    }
    .preview-dialog{
        pre{
            margin: 0;
            white-space: pre-line;
        }
        .el-form-item__label{
            color: #9e9e9e;
        }
        .el-form-item{
            margin: 4px 0;
        }
    }
</style>

<script>
    import axios from 'axios'
    import selectMapMixin from 'mixins/selectMapMixin'
    import { Loading } from 'element-ui'

    export default {
        mixins: [selectMapMixin],
        data () {
            return {
                configMap: this.$store.state.baseData.selectMap,
                formLabelWidth: '110px',
                hunterList: [],
                paymentRuleList: [],
                baseData: null,
                dialogVisible: false
            }
        },
        computed: {
            hasSalary () {
                return this.$store.state.user.paymentFlag
            }
        },
        created () {
            this.hasSalary && this.$axios.get('/payment/template/list.api?state=1&pageSize=100').then(res => {
                this.paymentRuleList = res.result.list
            })
        },
        methods: {
            getHeaderInfos (ids) {
                let list = []
                if (ids === '') {
                    return list
                }
                ids = ids.split(',')
                this.hunterList.forEach(company => {
                    if (company.list) {
                        company.list.forEach(user => {
                            if (ids.indexOf(String(user.value)) > -1) {
                                list.push({
                                    companyName: company.text,
                                    userName: user.text
                                })
                            }
                        })
                    }
                })
                return list
            },
            show (data) {
                this.dialogVisible = true
                console.log(this.paymentRuleList)
                this.paymentRuleList.forEach(item => {
                    console.log(item.id === data.paymentId)
                    if (item.id === data.paymentId) {
                        data.paymentName = item.name
                    }
                })
                this.baseData = data
            },
            getSupplierStr(item) {
                if(item.name) {
                    return `${item.companyName}-${item.name}`
                }
                
                return item.companyName
            }
        }
    }
</script>



// WEBPACK FOOTER //
// previewPosition.vue?024a26d8